import { render, staticRenderFns } from "./TextEditorBox.vue?vue&type=template&id=e2337dea&scoped=true"
import script from "./TextEditorBox.vue?vue&type=script&lang=js"
export * from "./TextEditorBox.vue?vue&type=script&lang=js"
import style0 from "./TextEditorBox.vue?vue&type=style&index=0&id=e2337dea&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e2337dea",
  null
  
)

export default component.exports